import { IRawStyle, Separator } from "@fluentui/react";
import React, { CSSProperties } from "react";

import { ValidationResult } from "../../utils";
import { Grid } from "../layouts/grid/Grid";
import { GridColumn } from "../layouts/grid/GridColumn";
import { GridRow } from "../layouts/grid/GridRow";
import { ElevatedStack } from "../layouts/stack/ElevatedStack";
import { Stack } from "../layouts/stack/Stack";
import { Spinner } from "../progress/Spinner";
import { Dropzone } from "../surfaces/Dropzone";
import { Text } from "./Text";

interface DropzoneContentSectionProps {
    header?: string;
    isLoading: boolean;
    disabled?: boolean;
    style?: IRawStyle;
    accept?: string;
    maxFileSizeInMegabytes?: number;
    onDropFile(file: File): void;
    onDropFileError(validationResult: ValidationResult): void;
}

export const DropzoneContentSection = (props: DropzoneContentSectionProps): JSX.Element => {
    const { header, isLoading, disabled, style, onDropFile, onDropFileError, accept, maxFileSizeInMegabytes } = props;

    const sectionRootStyle: IRawStyle = {
        ...style
    };

    const headerHeight = 30;

    const headerStyle: CSSProperties = {
        height: headerHeight
    };

    const commandBarStyle: CSSProperties = {
        height: headerHeight
    };

    let separatorStyle: CSSProperties | undefined;

    const contentPadding = 10;

    let contentStyle: CSSProperties = {
        padding: contentPadding,
        height: "100%"
    };

    const height = Number(style?.height);

    if (height && !isNaN(height)) {
        const sectionPadding = 30;

        sectionRootStyle.padding = sectionPadding;

        const separatorPadding = 4;
        const separatorHeight = 19;

        separatorStyle = {
            height: separatorHeight,
            padding: separatorPadding
        };

        const contentHeight =
            height - sectionPadding - headerHeight - (separatorHeight + separatorPadding) - contentPadding;

        contentStyle = {
            padding: contentPadding,
            height: contentHeight,
            textAlign: "center"
        };
    }

    return (
        <ElevatedStack styles={{ root: sectionRootStyle }}>
            <Grid>
                <GridRow style={headerStyle}>
                    <GridColumn sm={5} style={{ paddingTop: 3, paddingBottom: 3 }}>
                        <Text variant="large">{header ?? "Upload"}</Text>
                    </GridColumn>
                    {isLoading && (
                        <GridColumn sm={7} style={commandBarStyle}>
                            <Stack horizontal={true} horizontalAlign="end" style={commandBarStyle}>
                                <Spinner style={{ alignSelf: "end" }} />
                            </Stack>
                        </GridColumn>
                    )}
                </GridRow>
                <Separator style={separatorStyle} />
                <GridRow style={contentStyle}>
                    <Dropzone
                        onDrop={onDropFile}
                        onDropFileError={onDropFileError}
                        disabled={isLoading || !!disabled}
                        accept={accept}
                        maxFileSizeInMegabytes={maxFileSizeInMegabytes}
                    />
                </GridRow>
            </Grid>
        </ElevatedStack>
    );
};
